module.exports = __webpack_public_path__ + "static/SarahBook2.1f589838.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/pages/SarahBook2.jpg
// module id = 662
// module chunks = 106182774615790